export enum AbilitySubjects {
    app = 'app',
    protectedApp = 'protectedApp',
    mainPortal = 'mainPortal',
    userManagement = 'userManagement',
    abilities = 'abilities',
}
